var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:_vm.getClasses,attrs:{"color":_vm.color,"min-width":_vm.getMinWidth,"min-height":_vm.minHeight,"max-height":_vm.maxHeight,"height":_vm.pHeight,"outlined":_vm.outlined,"retain-focus-on-click":_vm.retainFocusOnClick,"tile":_vm.tile}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }